import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";






















import ScopeGroupFormSelect from "../../../../auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect";

import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";

import MembersGroupFormSelect from "../../../../auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect";



import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";
















export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        scopeGroupContext: "",
        
    
        
        description: "",
        
    
        
        parentScopeGroupId: null,
        
    
        
        membersGroupId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.membersGroupId = PrimaryMembersGroup.fromQuery(location.state?.membersGroupId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        scopeGroupContext:
        string()
        .trim()
        .min(1, msg`Scope Group Context is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        parentScopeGroupId:
        string()
                .nanoid(msg`Parent Scope Group is required`)
                .nullish(),
    
    
        membersGroupId:
        string()
                .nanoid(msg`Member Group is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const ScopeGroupAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'scopeGroupContext' }
       aria-label="scopeGroupContext"
       data-testid="scopeGroupContext"
       label={t`Scope Group Context`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <ScopeGroupFormSelect
        type="dynamicSelect"
        name="parentScopeGroupId"
        label={t`Parent Scope Group`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
           
   
    
    <MembersGroupFormSelect
        type="dynamicSelect"
        name="membersGroupId"
        label={t`Member Group`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default ScopeGroupAddForm;
